const other = {
	'other.help.title': 'SSS',
	'other.serve.title': 'Hizmet Şartları',
	'other.serve.tips': 'Son güncelleme 30 Temmuz 2024',
	'other.privacy.title': 'Gizlilik Politikası',
	'other.privacy.tips': 'Son güncelleme 14 Ocak 2023',

	'orders.no.data': 'Sipariş Kimliği bulunamadı',
	'siparişler.detaylar.gönder': 'Gönder',
	'orders.details.receive': 'Al',
	'orders.details.orderid': 'Sipariş Kimliği',
	'orders.details.difftime': 'Kalan süre',
	'orders.details.type': 'Sipariş türü',
	'orders.details.status1': 'Sabit döviz kuru',
	'orders.details.status2': 'Dalgalı döviz kuru',
	'orders.details.createTime': 'Oluşturma zamanı',
	'siparişler.detaylar.adres': 'adres',
	'orders.details.with.amount': 'Tutar dahil',
	'orders.details.b.send': 'Gönder',
	'orders.details.b.send1': 'Alıcı adresi:',
	'orders.details.b.s': 'Döviz kuru teslimat sırasında belirlenecektir',
	'orders.details.b.s1': 'Ağ onayı. ',
	'orders.details.b.s2': 'Teslimat adresi',
	'orders.details.progress.1': 'Para yatırma bekleniyor',
	'orders.details.progress.2': 'Onay bekleniyor',
	'orders.details.progress.3': 'Geri ödemeyi gerçekleştir',
	'orders.details.progress.4': 'Tamamlandı',

	'orders.list.1': 'Tarih/OROER Kimliği',
	'siparişler.listesi.2': 'Gönder',
	'siparişler.listesi.3': 'Al',
	'orders.list.4': 'Teslimat adresi',
	'orders.title': 'Tamamlanan Siparişler',
}

export default other
